/* ------------------------------------------------------------------
   JOUBERT — comportements des sections de la fiche produit.
   Sans dépendance, sans surveillance permanente : tout passe par
   des écouteurs passifs et un observateur d'intersection.
   ------------------------------------------------------------------ */
(() => {
  const doux = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── La coupe : elle suit le défilement, et le visiteur peut la tenir ── */
  document.querySelectorAll('[data-jb-coupe]').forEach((coupe) => {
    if (doux) return;
    let position = 0;      // position affichée, en pourcentage
    let maintien = false;  // le visiteur tient la barre
    let ecart = 0;         // ce qu'il a ajouté, résorbé au défilement suivant

    const cible = () => {
      const r = coupe.getBoundingClientRect();
      const course = innerHeight * 0.75 + r.height * 0.5;
      return Math.min(Math.max((innerHeight * 0.88 - r.top) / course, 0), 1) * 100;
    };
    const poser = (p) => {
      position = p;
      coupe.style.setProperty('--x', p.toFixed(1) + '%');
    };
    const avancement = () => {
      if (maintien) return;
      if (Math.abs(ecart) > 0.4) ecart *= 0.88; else ecart = 0;
      poser(cible() + ecart);
    };
    addEventListener('scroll', () => requestAnimationFrame(avancement), { passive: true });
    addEventListener('resize', avancement);
    avancement();

    // --x se compte depuis la droite : la coupe doit suivre le pointeur, pas partir à l'opposé
    const depuisPointeur = (e) => {
      const r = coupe.getBoundingClientRect();
      const fraction = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1);
      poser((1 - fraction) * 100);
    };
    coupe.addEventListener('dragstart', (e) => e.preventDefault());
    coupe.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      maintien = true;
      coupe.classList.add('tenue');
      coupe.setPointerCapture(e.pointerId);
      depuisPointeur(e);
    });
    coupe.addEventListener('pointermove', (e) => { if (maintien) depuisPointeur(e); });
    const relacher = () => {
      if (!maintien) return;
      maintien = false;
      coupe.classList.remove('tenue');
      ecart = position - cible();
    };
    coupe.addEventListener('pointerup', relacher);
    coupe.addEventListener('pointercancel', relacher);

    // les objets suivent la souris de quelques pixels : la scène respire sans bouger vraiment
    let attente = false;
    coupe.addEventListener('pointermove', (e) => {
      if (attente) return;
      attente = true;
      requestAnimationFrame(() => {
        const r = coupe.getBoundingClientRect();
        const dx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        const dy = ((e.clientY - r.top) / r.height - 0.5) * 2;
        coupe.style.setProperty('--mx', (dx * 18).toFixed(1) + 'px');
        coupe.style.setProperty('--my', (dy * 10).toFixed(1) + 'px');
        attente = false;
      });
    }, { passive: true });
    coupe.addEventListener('pointerleave', () => {
      coupe.style.setProperty('--mx', '0px');
      coupe.style.setProperty('--my', '0px');
    });
  });

  /* ── La bande atelier : la vidéo ne tourne qu'à l'écran ──────────── */
  document.querySelectorAll('[data-jb-film]').forEach((bande) => {
    const video = bande.querySelector('video');
    const bouton = bande.querySelector('[data-jb-film-bouton]');
    if (!video || !bouton) return;

    const lecture = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M5 3l8 5-8 5V3Z"/></svg>';
    const pause = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M5.5 3v10M10.5 3v10"/></svg>';
    let voulue = !doux;

    const refleter = () => {
      const joue = !video.paused;
      bouton.innerHTML = joue ? pause : lecture;
      bouton.setAttribute('aria-label', joue ? (bouton.dataset.jbFilmPause || 'Pause') : (bouton.dataset.jbFilmLecture || 'Play'));
    };
    bouton.addEventListener('click', () => {
      voulue = video.paused;
      if (voulue) video.play().catch(() => {}); else video.pause();
      refleter();
    });
    video.addEventListener('play', refleter);
    video.addEventListener('pause', refleter);
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting && voulue) video.play().catch(() => {});
      else if (!e.isIntersecting) video.pause();
    }, { threshold: 0.25 }).observe(bande);
    refleter();
  });
})();

/* ── La galerie au doigt ───────────────────────────────────────────
   Sur ordinateur, un clic sur la photo ouvre deja le plein ecran. Sur
   mobile le theme ne l'ouvre qu'avec la petite loupe : on accepte aussi
   un appui franc sur l'image, sans gener le glissement d'une photo a
   l'autre (on exige un doigt qui n'a pas bouge et un appui bref). */
(() => {
  document.querySelectorAll('.product-gallery').forEach((galerie) => {
    const loupe = galerie.querySelector('.product-gallery__zoom-button');
    if (!loupe) return;
    let x = 0, y = 0, debut = 0;
    galerie.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse') return;
      x = e.clientX; y = e.clientY; debut = Date.now();
    }, { passive: true });
    galerie.addEventListener('pointerup', (e) => {
      if (e.pointerType === 'mouse' || !debut) return;
      const duree = Date.now() - debut;
      debut = 0;
      if (e.target.closest('button, a, [role="button"], .product-gallery__thumbnail-list')) return;
      if (duree > 400) return;
      if (Math.hypot(e.clientX - x, e.clientY - y) > 10) return;
      loupe.click();
    }, { passive: true });
  });
})();

/* ── Les avis : flèches et pagination ──────────────────────────────
   Un pas = la largeur d'un avis plus l'écart, pour retomber juste.
   Les flèches s'éteignent en bout de piste : on voit qu'on est arrivé. */
(() => {
  document.querySelectorAll('[data-jb-avis-piste]').forEach((piste) => {
    const cadre = piste.closest('.jb-preuves');
    const fleches = cadre ? cadre.querySelectorAll('[data-jb-avis-fleches] .jb-fleche') : [];
    if (!fleches.length) return;

    const premier = piste.firstElementChild;
    const pas = () => {
      if (!premier) return piste.clientWidth;
      const ecart = parseFloat(getComputedStyle(piste).columnGap) || 0;
      return premier.getBoundingClientRect().width + ecart;
    };

    const refleter = () => {
      const fin = piste.scrollWidth - piste.clientWidth - 2;
      fleches.forEach((f) => {
        const sens = Number(f.dataset.sens);
        f.disabled = sens < 0 ? piste.scrollLeft <= 2 : piste.scrollLeft >= fin;
      });
    };

    fleches.forEach((f) => f.addEventListener('click', () => {
      piste.scrollBy({ left: Number(f.dataset.sens) * pas() });
    }));

    /* Glisser à la souris, comme la galerie du Journal (le tactile défile
       nativement). L'aimantation est coupée pendant le geste et reprend au
       relâchement : la piste retombe sur un avis. */
    let bas = false, x0 = 0, s0 = 0, bouge = false;
    piste.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      bas = true; bouge = false; x0 = e.clientX; s0 = piste.scrollLeft;
    });
    addEventListener('pointermove', (e) => {
      if (!bas) return;
      const dx = e.clientX - x0;
      if (!bouge && Math.abs(dx) <= 4) return;
      if (!bouge) {
        bouge = true;
        piste.classList.add('jb-glisse');
        piste.style.scrollSnapType = 'none'; piste.style.scrollBehavior = 'auto';
      }
      piste.scrollLeft = s0 - dx;
    });
    addEventListener('pointerup', () => {
      if (!bas) return;
      bas = false;
      piste.classList.remove('jb-glisse');
      piste.style.scrollSnapType = ''; piste.style.scrollBehavior = '';
    });
    piste.addEventListener('click', (e) => {
      if (bouge) { e.preventDefault(); e.stopPropagation(); bouge = false; }
    }, true);
    piste.addEventListener('dragstart', (e) => e.preventDefault());
    /* Sans cela, la souris surligne le texte des avis au lieu de les faire glisser. */
    piste.addEventListener('mousedown', (e) => { if (e.button === 0) e.preventDefault(); });

    let attente = false;
    piste.addEventListener('scroll', () => {
      if (attente) return;
      attente = true;
      requestAnimationFrame(() => { refleter(); attente = false; });
    }, { passive: true });
    addEventListener('resize', refleter);
    refleter();
  });
})();

/* ── Le prix dans le bouton d'achat ────────────────────────────────
   La maquette annonce « Ajouter au panier · 399 € » : le montant sous
   le doigt evite d'avoir a remonter la page pour le verifier.
   Au changement de variante, le theme remplace les blocs : on ne garde
   donc aucune reference, on relit la colonne a chaque fois. */
(() => {
  const colonne = document.querySelector('.product-info');
  if (!colonne) return;
  let socle = '';

  const poser = () => {
    const bouton = colonne.querySelector('[name="add"], button[type="submit"]');
    const prix = colonne.querySelector('.price, [class*="price"]');
    if (!bouton || !prix) return;
    const libelle = bouton.querySelector('span:not(.sr-only)') || bouton;
    const actuel = libelle.textContent.trim();
    if (!socle) socle = actuel.split(' · ')[0];
    const brut = (prix.textContent || '').replace(/\s+/g, ' ');
    const trouve = brut.match(/[\d   .,]*\d\s*(?:€|EUR)/);
    const voulu = trouve ? socle + ' · ' + trouve[0].trim() : socle;
    if (actuel !== voulu) libelle.textContent = voulu;
  };

  let attente = false;
  const observateur = new MutationObserver(() => {
    if (attente) return;
    attente = true;
    requestAnimationFrame(() => { attente = false; poser(); });
  });
  observateur.observe(colonne, { childList: true, subtree: true, characterData: true });
  poser();
})();

/* ── Le premier depliant et la premiere question, ouverts ──────────
   La maquette montre les cotes du sac d'emblee, sur mobile comme sur
   grand ecran : c'est la question que tout le monde se pose. */
(() => {
  // le theme fait pivoter le + en croix a partir de aria-expanded,
  // pas de l'attribut open : il faut poser les deux
  const ouvrir = (d) => { if (!d) return; d.open = true; d.setAttribute('aria-expanded', 'true'); };
  ouvrir(document.querySelector('.product-info details'));
  ouvrir(document.querySelector('.shopify-section--faq details'));
})();

/* ── La barre d'achat mobile ───────────────────────────────────────
   Elle est la des que le bouton de la colonne n'est pas a l'ecran, au-dessus
   comme en dessous. Mesure au defilement plutot qu'en IntersectionObserver,
   qui reste muet sur un saut d'ancre. */
(() => {
  const barre = document.querySelector('[data-jb-barre]');
  const colonne = document.querySelector('.product-info');
  if (!barre || !colonne) return;

  const boutonBarre = barre.querySelector('[data-jb-barre-bouton]');
  const prixBarre = barre.querySelector('[data-jb-barre-prix]');
  const choix = barre.querySelector('[data-jb-barre-option]');

  const boutonReel = () => colonne.querySelector('[name="add"], button[type="submit"]');

  /* ── Montrer, cacher ── */
  let attente = false;
  const mesurer = () => {
    attente = false;
    const b = boutonReel();
    // des que le bouton de la colonne n'est pas a l'ecran, au-dessus comme en dessous :
    // en arrivant sur la fiche, la barre est deja la
    const r = b && b.getBoundingClientRect();
    document.body.classList.toggle('jb-barre-visible', !!b && !(r.bottom > 0 && r.top < innerHeight));
    // variante épuisée : le bouton de la barre le dit, comme celui de la colonne
    if (b) {
      const epuise = b.disabled && b.getAttribute('aria-busy') !== 'true';
      boutonBarre.disabled = epuise;
      const libelle = epuise ? boutonBarre.dataset.epuise : boutonBarre.dataset.ajouter;
      if (libelle && boutonBarre.textContent.trim() !== libelle) boutonBarre.textContent = libelle;
    }
    // jb-defilee appartient au bouton de conversation, qui vit sur tout le site
    // la hauteur reelle de la barre decide de celle du bouton de conversation
    document.body.style.setProperty('--jb-h-barre', barre.offsetHeight + 'px');
  };
  addEventListener('scroll', () => {
    if (attente) return;
    attente = true;
    requestAnimationFrame(mesurer);
  }, { passive: true });
  addEventListener('resize', mesurer);
  mesurer();

  /* ── Le bouton de la barre passe la commande a celui de la colonne ── */
  boutonBarre.addEventListener('click', () => {
    const b = boutonReel();
    if (!b) return;
    // la barre montre l'attente tout de suite ; le vrai bouton, hors ecran,
    // porte aria-busy le temps de l'ajout et la barre le reflete
    boutonBarre.setAttribute('aria-busy', 'true');
    b.click();
  });
  const refletOccupe = () => {
    const b = boutonReel();
    if (!b) return;
    if (b.getAttribute('aria-busy') === 'true') boutonBarre.setAttribute('aria-busy', 'true');
    else boutonBarre.removeAttribute('aria-busy');
  };
  new MutationObserver(refletOccupe).observe(colonne, { attributes: true, subtree: true, attributeFilter: ['aria-busy'] });
  new MutationObserver(() => requestAnimationFrame(mesurer)).observe(colonne, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled'] });
  document.addEventListener('variant:add', () => boutonBarre.removeAttribute('aria-busy'));
  document.addEventListener('cart:error', () => boutonBarre.removeAttribute('aria-busy'));

  /* ── Le rappel de doublure pilote le vrai selecteur ──
     On coche le bouton radio et on annonce le changement, sans le cliquer :
     un clic lui donnerait le focus et le navigateur ramenerait la colonne
     dans l'ecran, ce qui deplacerait la page sous le doigt. La hauteur de
     la colonne peut malgre tout bouger a la reconstruction : on retient la
     position et on la rend, le temps que le theme finisse. */
  let position = null;
  if (choix) {
    choix.addEventListener('change', () => {
      const etiquette = Array.from(colonne.querySelectorAll('.variant-picker__option-values label'))
        .find((l) => l.textContent.trim().toLowerCase() === choix.value.trim().toLowerCase());
      if (!etiquette) return;
      const radio = etiquette.htmlFor ? document.getElementById(etiquette.htmlFor) : null;
      position = scrollY;
      setTimeout(() => { position = null; }, 1200);
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        etiquette.click();
      }
    });
  }

  /* ── Prix et disponibilite suivent la colonne ──
     Au changement de variante le theme remplace ses blocs : on relit. */
  let reflet = false;
  const refleter = () => {
    reflet = false;
    if (position !== null && Math.abs(scrollY - position) > 2) scrollTo(0, position);
    const prix = colonne.querySelector('.price, [class*="price"]');
    if (prix && prixBarre) {
      const trouve = (prix.textContent || '').replace(/\s+/g, ' ').match(/[\d   .,]*\d\s*(?:€|EUR)/);
      if (trouve && prixBarre.textContent.trim() !== trouve[0].trim()) prixBarre.textContent = trouve[0].trim();
    }
    const b = boutonReel();
    if (b && boutonBarre.disabled !== b.disabled) boutonBarre.disabled = b.disabled;
    if (choix) {
      const actif = colonne.querySelector('.variant-picker__option-values input:checked + label');
      if (actif) {
        const v = actif.textContent.trim();
        if (choix.value !== v) choix.value = v;
      }
    }
  };
  new MutationObserver(() => {
    if (reflet) return;
    reflet = true;
    requestAnimationFrame(refleter);
  }).observe(colonne, { childList: true, subtree: true, characterData: true });
  refleter();
})();
